import { Component, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Endpoint, HelpIndex } from '../../../models/enums';
import { Project } from '../../../models/project';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { DataAreaAndTreeComponent } from '../../data-area-and-tree/data-area-and-tree.component';
import { BaseModalComponent } from '../../../models/base-modal-component';

@Component({
    standalone: false,
    selector: 'res-export-project-modal',
    templateUrl: './export-project-modal.component.html'
})
export class ExportProjectModalComponent extends BaseModalComponent {
    @ViewChild(DataAreaAndTreeComponent, { static: true }) dataAreaAndTreeComponent: DataAreaAndTreeComponent;

    modalTitle = 'Export Project';
    modalAutomationId = 'export-project';
    verifyRequiredValidator = true;
    primaryButtonLabel = 'Export Project';
    secondaryButtonLabel = 'Cancel';
    modalHelpIndex = HelpIndex.export_project_dlg;
    isBusy = false;
    isBusyMessage = '';
    sourceFiles = 'include-files';
    selectedPath: string;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService) {
        super(modalService, modalRef);
        this.isBusy = false;
    }

    isPrimaryButtonEnabled(): boolean {
        return !!this.sourceFiles && this.dataAreaAndTreeComponent.selectedDataArea &&
            this.dataAreaAndTreeComponent.selectedDataArea !== 'No Data Areas' && !this.isBusy;
    }

    onDataAreaAndTreeChange(): void {
        this.selectedPath = this.dataAreaAndTreeComponent.selectedPath ? this.dataAreaAndTreeComponent.selectedPath.handle : '';

        if (this.selectedPath.includes(this.dataAreaAndTreeComponent.selectedDataArea.path)) {
            this.selectedPath = this.selectedPath.replace(this.dataAreaAndTreeComponent.selectedDataArea.path, '');
        }
    }

    exportProject(): void {
        this.isBusy = true;
        this.isBusyMessage = 'Exporting Project ...';
        const request = {
            includeConnectorReferences: this.sourceFiles !== 'include-files',
            includeFiles: this.sourceFiles === 'include-files',
            exportDirectoryName: this.selectedPath.split('\\').join('/'),
            dataAreaHandle: this.dataAreaAndTreeComponent.selectedDataArea.handle,
            taskDescription: 'Exporting Project',
            compactToCaseData: false,
            projectHandle: (this.modalData as Project).handle,
            attributes: [{ name: 'userprojecttype', value: 'dr_eca' }, { name: 'projecttype', value: 'dr_eca' }]
        };

        this.restService.post(Endpoint.orgManager_exportProject, request, true, true).then(response => {
            if (response) {
                this.commonService.openInformationToastNotification('Project Export Started');
            }
            this.closeModal();
        });
        this.isBusy = false;
    }

    clearPathTreeSelection(): void {
        this.dataAreaAndTreeComponent.genericTree.selectedNode = null;
    }
}
